import React from "react";
import { Box, Button, IconAvatar, Stack, Typography } from "../components";
export const EmptyState = ({ icon, title, subtitle, buttonText, buttonIcon, onClick, border = true, buttonWithMenu, sx, }) => {
    return (React.createElement(Box, { sx: Object.assign(Object.assign({ paddingY: 8 }, (border && {
            border: (theme) => `1px solid ${theme.palette.stroke[100]}`,
            borderRadius: (theme) => theme.radius.default,
        })), sx) },
        React.createElement(Stack, { gap: 2, alignItems: "center", sx: {
                margin: "auto",
                maxWidth: (theme) => theme.spacing(60),
            } },
            React.createElement(IconAvatar, { color: "surface", sx: { borderRadius: (theme) => theme.radius.default } }, icon),
            React.createElement(Typography, { variant: "body2", fontWeight: "bold", align: "center" }, title),
            subtitle && (React.createElement(Typography, { variant: "body2", fontWeight: "regular", align: "center", sx: {
                    color: (theme) => theme.palette.disabled.onContainer,
                } }, subtitle)),
            buttonText && onClick && (React.createElement(Button, { variant: "outlined", color: "surface", onClick: onClick, startNode: buttonIcon }, buttonText)),
            buttonWithMenu)));
};
//# sourceMappingURL=EmptyState.js.map